<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-list-item-avatar
        v-bind="attrs"
        v-on="on"
        :size="size"
        class="bookie-icon"
        :style="{
          'background-color': iconBackground,
          'margin-top': top ? '-20px' : 'default',
          'border-radius': '50%',
          border: iconBorder || 'none',
          'user-select': 'none'
        }"
        @click="$emit('click')"
      >
        <span :style="{ color: iconColor }" class="caption">
          {{ iconInitials }}
        </span>
      </v-list-item-avatar>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import Constants from "../lib/constants";

export default {
  name: "BookieIcon",
  props: ["bookie", "size", "top"],
  computed: {
    iconColor() {
      return Constants.BOOKIE_ICONS[this.bookie]?.foreground || "white";
    },
    iconBorder() {
      return Constants.BOOKIE_ICONS[this.bookie]?.border || "black";
    },
    iconBackground() {
      return Constants.BOOKIE_ICONS[this.bookie]?.background || "black";
    },
    iconInitials() {
      return Constants.BOOKIE_ICONS[this.bookie]?.initials || "N/A";
    },
    tooltip() {
      return Constants.BOOKIE_DESCRIPTIONS[this.bookie] || this.bookie;
    }
  }
};
</script>

<style lang="scss"></style>
